import React, { createContext, useContext, useReducer, useEffect } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "orgalife_cart";

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      const key = `${action.item.id}_${action.item.variant}`;
      const existing = state.find((i) => `${i.id}_${i.variant}` === key);
      if (existing) {
        return state.map((i) =>
          `${i.id}_${i.variant}` === key ? { ...i, qty: i.qty + action.item.qty } : i
        );
      }
      return [...state, { ...action.item }];
    }
    case "REMOVE":
      return state.filter((i) => `${i.id}_${i.variant}` !== `${action.id}_${action.variant}`);
    case "UPDATE_QTY":
      return state.map((i) =>
        `${i.id}_${i.variant}` === `${action.id}_${action.variant}` ? { ...i, qty: action.qty } : i
      );
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, [], () => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => dispatch({ type: "ADD", item });
  const removeFromCart = (id, variant) => dispatch({ type: "REMOVE", id, variant });
  const updateQty = (id, variant, qty) => dispatch({ type: "UPDATE_QTY", id, variant, qty });
  const clearCart = () => dispatch({ type: "CLEAR" });
  const totalItems = cart.reduce((sum, i) => sum + i.qty, 0);
  const subtotal = cart.reduce((sum, i) => sum + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQty, clearCart, totalItems, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
